import { render } from "./Tasks.vue?vue&type=template&id=432bdc44&scoped=true"
import script from "./Tasks.vue?vue&type=script&lang=js"
export * from "./Tasks.vue?vue&type=script&lang=js"

import "./Tasks.vue?vue&type=style&index=0&id=432bdc44&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-432bdc44"

export default script